const postTasksPayload = (payload) => {
  const { videoUrls, notes } = payload;

  return {
    videoUrls: videoUrls.map((item) => item.value),
    note: notes,
  };
};

export default postTasksPayload;
